export const filterTypes = {
    0: 'ALL SWAPS',
    1: 'IN-PROCESS SWAPS',
    2: 'SCHEDULED SWAPS'
};